import { render, staticRenderFns } from "./QuestionBank.vue?vue&type=template&id=adccad1c&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"
import style0 from "./QuestionBank.vue?vue&type=style&index=0&id=adccad1c&prod&scoped=true&lang=css"
import style1 from "./QuestionBank.vue?vue&type=style&index=1&id=adccad1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adccad1c",
  null
  
)

export default component.exports